/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCalendarDay/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaCalendarTimePicker from 'DesignSystem/TysiaCalendarBlocks/TysiaCalendarTimePicker/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaCalendarDay({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarDay",
  dayRef,
  isSelected,
  disabled,
  isShowingTimePicker,
  isDisabled,
  height = 50,
  onClick,
  day = 10,
  time,
  onChange,
  slots,
  timezone,
  isNative,
  dayDate
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected,isDisabled})
let dtTysiacalendardayBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.backgroundColor.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTysiacalendardayBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.borderColor.primary.base'
        })
let dtTysiacalendardayBackgroundcolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.backgroundColor.primary.hovered'
        })
let dtTysiacalendardayBordercolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.borderColor.primary.hovered'
        })
let dtTysiacalendardayBackgroundcolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.backgroundColor.primary.selected'
        })
let dtTysiacalendardayBordercolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.borderColor.primary.selected'
        })
let dtTysiacalendardayBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.backgroundColor.primary.disabled'
        })
let dtTysiacalendardayBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.borderColor.primary.disabled'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTysiacalendardayTextcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.textColor.primary.base'
        })
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
let dtTypographyFontweightSemibold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.semibold'
        })
let dtTysiacalendardayTextcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.textColor.primary.disabled'
        })
let dtTysiacalendardayTextcolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.textColor.primary.hovered'
        })
let dtTysiacalendardayTextcolorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarDay.textColor.primary.selected'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaCalendarDay.Vertical"
  data-view-path={viewPath}
 ref={dayRef}
 style={{'--bblr-2-SewqG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-SewqG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-SewqG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-SewqG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-SewqG': isSelected ? dtTysiacalendardayBackgroundcolorPrimarySelected : isHovered ? dtTysiacalendardayBackgroundcolorPrimaryHovered : disabled ? dtTysiacalendardayBackgroundcolorPrimaryDisabled : isShowingTimePicker ? dtTysiacalendardayBackgroundcolorPrimarySelected : dtTysiacalendardayBackgroundcolorPrimaryBase,'--bc-6-SewqG': isSelected ? dtTysiacalendardayBordercolorPrimarySelected : isHovered ? dtTysiacalendardayBordercolorPrimaryHovered : disabled ? dtTysiacalendardayBordercolorPrimaryDisabled : dtTysiacalendardayBordercolorPrimaryBase}}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="TysiaCalendarDay.Vertical:1"
  data-view-path={viewPath}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--h-7-SewqG': typeof height === 'number' ? `${height}px` : height,'--mb-8-SewqG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-9-SewqG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mr-10-SewqG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-11-SewqG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={isSelected ? "6px" : "0px"}
 textAlign="center"
 color={isSelected ? dtTysiacalendardayTextcolorPrimarySelected : isHovered ? dtTysiacalendardayTextcolorPrimaryHovered : isShowingTimePicker ? dtTysiacalendardayTextcolorPrimarySelected : dtTysiacalendardayTextcolorPrimaryBase}
 fontSize={dtTypographyFontsizeL}
 fontWeight={dtTypographyFontweightSemibold}
 text={day}
 translateY={isSelected ? "-6px" : "0px"}
/>
<fromFlow.When is={isSelected}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={-4}
 textAlign="center"
 text={time}
 color={dtTysiacalendardayTextcolorPrimarySelected}
 bottom="6 easeOut"
 fontSize={10}
/>
</fromFlow.When>
</button>
<fromFlow.When is={isShowingTimePicker}>
<TysiaCalendarTimePicker
  viewPath={`${viewPath}/TysiaCalendarTimePicker`}
 onClick={onChange}
 from={slots}
 isSelected={isSelected}
 timezone={timezone}
 isNative={isNative}
 dayDate={dayDate}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}